/**
 * MENAHUB PROFESSIONAL MENU - WITH SCROLL LOCK
 * - Show only 5 items, rest in More dropdown
 * - Gray overlay blocks background scrolling
 * - Mega menu content remains scrollable
 * - Smooth animations
 */

(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    activeClass: 'active',
    hiddenClass: 'menahub-hidden',
    overlayClass: 'menahub-overlay',
    bodyLockClass: 'menahub-menu-open',
    maxVisibleItems: 5,
    hoverDelay: 100,
    closeDelay: 300,
    desktopBreakpoint: 992
  };
  
  // State management
  let state = {
    currentActiveItem: null,
    hoverTimer: null,
    closeTimer: null,
    overlay: null,
    moreDropdown: null,
    scrollPosition: 0
  };
  
  /**
   * Initialize the menu system
   */
  function init() {
    if (window.innerWidth < CONFIG.desktopBreakpoint) {
      return;
    }
    
    createOverlay();
    setupMoreDropdown();
    bindMenuItems();
    bindOutsideClick();
    bindKeyboardNav();
    bindWindowResize();
  }
  
  /**
   * Create overlay element
   */
  function createOverlay() {
    state.overlay = document.createElement('div');
    state.overlay.className = CONFIG.overlayClass;
    document.body.appendChild(state.overlay);
    
    state.overlay.addEventListener('click', closeAllMenus);
  }
  
  /**
   * Lock body scroll
   */
  function lockBodyScroll() {
    // Save current scroll position
    state.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    // Add lock class to body
    document.body.classList.add(CONFIG.bodyLockClass);
    
    // Set body to fixed position to prevent scroll
    document.body.style.top = `-${state.scrollPosition}px`;
  }
  
  /**
   * Unlock body scroll
   */
  function unlockBodyScroll() {
    // Only unlock if body was actually locked (prevents scroll-to-top on every click)
    if (!document.body.classList.contains(CONFIG.bodyLockClass)) return;

    // Remove lock class
    document.body.classList.remove(CONFIG.bodyLockClass);

    // Remove fixed positioning
    document.body.style.top = '';

    // Restore scroll position
    window.scrollTo(0, state.scrollPosition);
  }
  
  /**
   * Setup More dropdown for items 6+
   */
  function setupMoreDropdown() {
    const menuList = document.querySelector('.menahub-menu');
    if (!menuList) return;
    
    const allItems = Array.from(menuList.querySelectorAll('.menahub-item'));
    
    // If 6 or fewer items, show all normally
    if (allItems.length <= CONFIG.maxVisibleItems) {
      return;
    }
    
    // Hide items after position 5
    const hiddenItems = allItems.slice(CONFIG.maxVisibleItems);
    hiddenItems.forEach(item => {
      item.classList.add(CONFIG.hiddenClass);
    });
    
    // Create More dropdown
    const moreItem = document.createElement('li');
    moreItem.className = 'menahub-item menahub-more-item';
    moreItem.innerHTML = `
      <a href="#" class="menahub-link">More</a>
      <ul class="menahub-more-dropdown"></ul>
    `;
    
    const moreDropdown = moreItem.querySelector('.menahub-more-dropdown');
    state.moreDropdown = moreDropdown;
    
    // Add hidden items to More dropdown
    hiddenItems.forEach(item => {
      const link = item.querySelector('.menahub-link');
      if (link) {
        const dropdownItem = document.createElement('li');
        dropdownItem.className = 'menahub-more-item';
        dropdownItem.innerHTML = `
          <a href="${link.href}" class="menahub-more-link">${link.textContent}</a>
        `;
        moreDropdown.appendChild(dropdownItem);
      }
    });
    
    // Add More item to menu
    menuList.appendChild(moreItem);
  }
  
  /**
   * Bind events to menu items
   */
  function bindMenuItems() {
    const menuItems = document.querySelectorAll('.menahub-item');
    
    menuItems.forEach(item => {
      const hasDropdown = item.querySelector('.menahub-mega-wrapper, .menahub-more-dropdown');
      
      if (!hasDropdown) return;
      
      // Add has-mega class
      if (!item.classList.contains('menahub-more-item')) {
        item.classList.add('has-mega');
      }
      
      // Mouse enter - with bigger hover area
      item.addEventListener('mouseenter', function() {
        clearTimeout(state.closeTimer);
        
        state.hoverTimer = setTimeout(() => {
          openMenu(item);
        }, CONFIG.hoverDelay);
      });
      
      // Mouse leave - with delay to allow moving to dropdown
      item.addEventListener('mouseleave', function(e) {
        clearTimeout(state.hoverTimer);
        
        // Check if mouse is moving to dropdown
        const dropdown = item.querySelector('.menahub-mega-wrapper, .menahub-more-dropdown');
        if (dropdown && dropdown.contains(e.relatedTarget)) {
          return; // Don't close
        }
        
        state.closeTimer = setTimeout(() => {
          closeMenu(item);
        }, CONFIG.closeDelay);
      });
      
      // Dropdown hover - keep open
      if (hasDropdown) {
        hasDropdown.addEventListener('mouseenter', function() {
          clearTimeout(state.closeTimer);
        });
        
        hasDropdown.addEventListener('mouseleave', function() {
          state.closeTimer = setTimeout(() => {
            closeMenu(item);
          }, CONFIG.closeDelay);
        });
      }
      
      // Click toggle
      const link = item.querySelector('.menahub-link');
      link.addEventListener('click', function(e) {
        if (hasDropdown) {
          e.preventDefault();
          
          if (item.classList.contains(CONFIG.activeClass)) {
            closeMenu(item);
          } else {
            openMenu(item);
          }
        }
      });
    });
  }
  
  /**
   * Open menu
   */
  function openMenu(item) {
    // Close currently open menu
    if (state.currentActiveItem && state.currentActiveItem !== item) {
      closeMenu(state.currentActiveItem);
    }
    
    // Open new menu
    item.classList.add(CONFIG.activeClass);
    state.currentActiveItem = item;
    
    // Show overlay and lock scroll
    if (state.overlay) {
      state.overlay.classList.add('show');
      lockBodyScroll();
    }
    
    // Position dropdown if needed
    const dropdown = item.querySelector('.menahub-mega, .menahub-more-dropdown');
    if (dropdown) {
      setTimeout(() => positionDropdown(item, dropdown), 10);
    }
  }
  
  /**
   * Close menu
   */
  function closeMenu(item) {
    item.classList.remove(CONFIG.activeClass);
    
    if (state.currentActiveItem === item) {
      state.currentActiveItem = null;
      
      // Hide overlay and unlock scroll
      if (state.overlay) {
        state.overlay.classList.remove('show');
        unlockBodyScroll();
      }
    }
  }
  
  /**
   * Close all menus
   */
  function closeAllMenus() {
    clearTimeout(state.hoverTimer);
    clearTimeout(state.closeTimer);
    
    const activeItems = document.querySelectorAll('.menahub-item.' + CONFIG.activeClass);
    activeItems.forEach(item => {
      item.classList.remove(CONFIG.activeClass);
    });
    
    state.currentActiveItem = null;
    
    if (state.overlay) {
      state.overlay.classList.remove('show');
      unlockBodyScroll();
    }
  }
  
  /**
   * Smart positioning for dropdowns
   */
  function positionDropdown(item, dropdown) {
    // Reset alignment classes
    dropdown.classList.remove('align-left', 'align-right');
    
    const rect = dropdown.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    
    // Check if overflows right
    if (rect.right > viewportWidth - 20) {
      dropdown.classList.add('align-right');
    }
    
    // Check if overflows left
    if (rect.left < 20) {
      dropdown.classList.add('align-left');
    }
  }
  
  /**
   * Bind outside click to close menus
   */
  function bindOutsideClick() {
    document.addEventListener('click', function(e) {
      const clickedInside = e.target.closest('.menahub-navigation');
      const clickedOnOverlay = e.target.classList.contains(CONFIG.overlayClass);
      
      if (!clickedInside || clickedOnOverlay) {
        closeAllMenus();
      }
    });
  }
  
  /**
   * Keyboard navigation
   */
  function bindKeyboardNav() {
    const menuItems = Array.from(document.querySelectorAll('.menahub-item'));
    
    menuItems.forEach((item, index) => {
      const link = item.querySelector('.menahub-link');
      
      if (!link) return;
      
      link.addEventListener('keydown', function(e) {
        // Escape key - close all
        if (e.key === 'Escape') {
          closeAllMenus();
          link.focus();
        }
        
        // Enter or Space - toggle
        if (e.key === 'Enter' || e.key === ' ') {
          const hasDropdown = item.querySelector('.menahub-mega-wrapper, .menahub-more-dropdown');
          
          if (hasDropdown) {
            e.preventDefault();
            
            if (item.classList.contains(CONFIG.activeClass)) {
              closeMenu(item);
            } else {
              openMenu(item);
            }
          }
        }
        
        // Arrow Right - next item
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const nextItem = menuItems[index + 1];
          if (nextItem) {
            const nextLink = nextItem.querySelector('.menahub-link');
            if (nextLink) nextLink.focus();
          }
        }
        
        // Arrow Left - previous item
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prevItem = menuItems[index - 1];
          if (prevItem) {
            const prevLink = prevItem.querySelector('.menahub-link');
            if (prevLink) prevLink.focus();
          }
        }
      });
    });
  }
  
  /**
   * Handle window resize
   */
  function bindWindowResize() {
    let resizeTimer;
    
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      
      resizeTimer = setTimeout(() => {
        if (window.innerWidth < CONFIG.desktopBreakpoint) {
          closeAllMenus();
        }
      }, 250);
    });
  }
  
  /**
   * Public API
   */
  window.MenahubMenu = {
    close: closeAllMenus,
    init: init
  };
  
  /**
   * Auto-initialize when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();